/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from '@material-ui/core/Toolbar';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useFirebase } from 'react-redux-firebase';
import { useNotifications } from '@components/Notifier';
import LoginForm from './LoginForm';
import useStyles, { StyledButton } from './Login.styles';

function Login({ dispatch }) {
    const { enqueueSnackbar: enqueueSnackbarAction, closeSnackbar: closeSnackbarAction } =
        useNotifications();
    const enqueueSnackbar = (...args) => dispatch(enqueueSnackbarAction(...args));
    const closeSnackbar = (...args) => dispatch(closeSnackbarAction(...args));

    const [loading, setLoading] = useState(false);
    const firebase = useFirebase();
    const classes = useStyles();
    const onLogin = (creds) => {
        setLoading(true);
        firebase
            .login(creds)
            .then(() => {
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                enqueueSnackbar({
                    message:
                        err.message ===
                        'A network error (such as timeout, interrupted connection or unreachable host) has occurred.'
                            ? 'You seem to be having internet connectivity issues. Please chack your connection and try again.'
                            : err.message,
                    options: {
                        key: new Date().getTime() + Math.random(),
                        variant: 'error',
                        // eslint-disable-next-line react/display-name
                        action: (key) => (
                            <IconButton onClick={() => closeSnackbar(key)}>
                                <CloseIcon />
                            </IconButton>
                        ),
                    },
                });
            });
    };

    return (
        <div className={classes.page}>
            <div className={classes.appBarWrapper}>
                <AppBar position="static" elevation={0}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.brand}>
                            <Link to="/">
                                <img src="/assets/white-logo.svg" alt="Deal Depot" />
                            </Link>
                        </Typography>
                        <div>
                            <StyledButton disabled size="large" startIcon={<ArrowForwardIcon />}>
                                Don’t have an account?
                            </StyledButton>
                            <StyledButton
                                component={Link}
                                to="/investors"
                                size="large"
                                variant="outlined">
                                GET STARTED
                            </StyledButton>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
            <Container component="main" maxWidth="sm">
                <LoginForm loading={loading} onSubmit={onLogin} />
            </Container>
        </div>
    );
}

Login.propTypes = {
    dispatch: PropTypes.func,
};

export default Login;
